// extracted by mini-css-extract-plugin
export default {"header":"pageHeader_header__+4DwF","header__nav":"pageHeader_header__nav__dt2pd"};